import { Routes } from "@/utils/routes";
import dayjs from "dayjs";
import { useSession } from "next-auth/react";
import { useCallback, useEffect } from "react";
import toast from "react-hot-toast";

const ONE_DAY_MS = 1e3 * 60 * 60 * 24;

/**
 * Automatically logs the user out when their session expires.
 */
export const useAutoLogout = () => {
  const session = useSession();

  const doLogout = useCallback(() => {
    window.location.assign(Routes.login);
  }, []);

  const doNotify = useCallback(() => {
    toast("Logging out in 5 seconds");
  }, []);

  useEffect(() => {
    if (session.data?.expires) {
      const diff = dayjs(session.data.expires).diff(dayjs());
      if (diff < 0) {
        doLogout();
      } else if (diff < ONE_DAY_MS) {
        const timeout = setTimeout(doLogout, diff);
        const timeout2 = diff > 5000 ? setTimeout(doNotify, diff - 5000) : null;

        return () => {
          clearTimeout(timeout);
          if (timeout2 != null) {
            clearTimeout(timeout2);
          }
        };
      }
    }
  }, [doLogout, doNotify, session]);
};

// export function useAutoLogoutV2() {
//   useEffect(() => {
//     const interval = setInterval(async () => {
//       const session = await getSession();
//       console.log(session)
//     }, 1000 * 15);
//     return () => clearInterval(interval);
//   }, []);
// }
